export default "__VITE_ASSET__58d74627__"